/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import ReactDOM from "react-dom"
import axios from "axios"
import PropTypes from "prop-types"
import { ParallaxProvider } from "react-scroll-parallax"
import { QueryClient, QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"
import { ToastProvider } from "react-toast-notifications"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import CookieConsent, { Cookies } from "react-cookie-consent"

// import Announcement from "./Announcement"
import "bootstrap/dist/css/bootstrap.min.css"
import "aos/dist/aos.css"

import "../style/style.css"
import "../style/responsive.css"


import Footer from "./footer"

import LogoMark from "../images/sparkle-cta.svg"

import { datadogRum } from "@datadog/browser-rum"

const Layout = (props) => {

  axios.defaults.headers.common["ngrok-skip-browser-warning"] = "1"
  datadogRum.init({
    applicationId: `${process.env.DATADOG_APPLICATION_ID}`,
    clientToken: `${process.env.DATADOG_CLIENT_TOKEN}`,
    site: `${process.env.DATADOG_SITE}`,
    service: `${process.env.DATADOG_SERVICE}`,
    env: `${process.env.DATADOG_ENVIRONMENT}`,
    sessionSampleRate: +process.env.DATADOG_SESSION_SAMPLE_RATE,
    sessionReplaySampleRate: +process.env.DATADOG_SESSION_REPLAY_SAMPLE_RATE,
    trackUserInteractions: process.env.DATADOG_TRACK_USER_INTERACTIONS,
    trackResources: process.env.DATADOG_TRACK_RESOURCES,
    trackLongTasks: process.env.DATADOG_TRACK_LONG_TASKS,
    silentMultipleInit: true,
    defaultPrivacyLevel: "mask-user-input",
  })
  datadogRum.startSessionReplayRecording()
  // if we're in dev mode

  if (process.env.NODE_ENV === "development") {
    // Set up react-axe to catch accessibility issues during development
    const axe = require("react-axe")
    axe(React, ReactDOM, 1000)
  }
// if we're in dev mode
if (process.env.NODE_ENV === "development") {
  // Set up react-axe to catch accessibility issues during development
  const axe = require("react-axe")
  axe(React, ReactDOM, 1000)
}

// const in1Hour = 1 / 24


  // const [popup, setPopup] = useState(false)
  let AOS

  useEffect(() => {
    AOS = require("aos")
    AOS.init()
  }, [])

  useEffect(() => {
    if (AOS) {
      AOS.refresh()
    }
  })

  const MyQueryClient = new QueryClient()

  return (
    <ParallaxProvider>
      <QueryClientProvider client={MyQueryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ToastProvider>
          <div className="website-wrapper">
            {props.children}

            {/* cta */}

            <Footer
              visible={props.downloadFooter}
              footerVisible={props.footerVisible}
            />
            <CookieConsent
              location="bottom"
              buttonText="Accept"
              declineButtonText="Decline"
              enableDeclineButton
              flipButtons
              overlay
              cookieName="gatsby-gdpr-google-analytics"
              style={{
                background: "#000",
                padding: "5px 20px",
              }}
              declineButtonStyle={{
                color: "#97D700",
                background: "rgb(70 184 57 / 36%)",
                border: "1px solid #97D700",
                borderRadius: "2rem",
                fontFamily: "inherit",
                fontWeight: "600",
                lineHeight: "25px",
                minHeight: "43px",
                padding: "8px 40px",
                fontSize: "14px",
              }}
              buttonStyle={{
                color: "white",
                background: "#97D700",
                border: "1px solid #97D700",
                borderRadius: "2rem",
                fontFamily: "inherit",
                fontWeight: "600",
                lineHeight: "25px",
                minHeight: "43px",
                padding: "8px 40px",
                fontSize: "14px",
              }}
              expires={150}
              onAccept={() => {
                Cookies.set("gatsby-gdpr-facebook-pixel", true)
              }}
            >
              <h3
                className="mb-3 sparkle--mont__900"
                style={{ fontSize: "16px" }}
              >
                Can we use optional cookies{" "}
                <span role="img" aria-label="img">
                  🍪
                </span>{" "}
                ?
              </h3>
              <p className="mb-0" style={{ fontSize: "13px" }}>
                We use  
                <span role="img" aria-label="img">
                  🍪
                </span>
                cookies to personalise your experience on Sparkle. We’re not
                talking about the crunchy, tasty kind. These cookies help us
                keep our website safe, give you a better experience and show
                more relevant ads. We won’t turn them on unless you accept.
              </p>
            </CookieConsent>
            {/* <Announcement show={popup} closePopup={() => hidePopup()} /> */}
          </div>
        </ToastProvider>
        <ToastContainer />
      </QueryClientProvider>
    </ParallaxProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
